export default __webpack_public_path__ + "static/media/layerRight1.9d802fbb.webp";